"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const styles = (0, _makeStyles.default)(theme => ({
  quantity: {
    alignItems: "center",
    display: "flex",
    height: "100%",
    position: "relative",
    zIndex: 0,
    "& input": {
      minHeight: "100%",
      paddingBottom: 0,
      paddingTop: 0,
      textAlign: "center"
    },
    "& input[type=number]": {
      "-moz-appearance": "textfield"
    },
    "& input::-webkit-outer-spin-button": {
      "-webkit-appearance": "none",
      margin: 0
    },
    "& input::-webkit-inner-spin-button": {
      "-webkit-appearance": "none",
      margin: 0
    }
  },
  textField: {
    height: "100%",
    position: "relative",
    width: 60,
    zIndex: 2
  },
  textFieldInput: {
    background: "#FFFFFF",
    borderRadius: 0,
    height: "100%",
    textAlign: "center"
  },
  button: {
    borderRadius: 0,
    height: "100%",
    minHeight: 0,
    minWidth: 0,
    padding: 0,
    position: "relative",
    width: 24,
    zIndex: 1
  },
  buttonRemove: {
    borderBottomLeftRadius: theme.shape.borderRadius,
    borderTopLeftRadius: theme.shape.borderRadius,
    marginRight: -1
  },
  buttonAdd: {
    borderBottomRightRadius: theme.shape.borderRadius,
    borderTopRightRadius: theme.shape.borderRadius,
    marginLeft: -1
  }
}));
var _default = exports.default = styles;